<template>
  <svg xmlns="http://www.w3.org/2000/svg" height="30" width="30" viewBox="4 0 40 48" preserveAspectRatio="xMidYMid meet">
    <path :fill="colorx" d="M22.5 37.95h3v-2h3q.65 0 1.075-.425Q30 35.1 30 34.45v-6.5q0-.65-.425-1.075-.425-.425-1.075-.425H21v-3.5h9v-3h-4.5v-2h-3v2h-3q-.65 0-1.075.425Q18 20.8 18 21.45v6.5q0 .65.425 1.075.425.425 1.075.425H27v3.5h-9v3h4.5ZM11 44q-1.2 0-2.1-.9Q8 42.2 8 41V7q0-1.2.9-2.1Q9.8 4 11 4h18.05L40 14.95V41q0 1.2-.9 2.1-.9.9-2.1.9Zm15.55-29.05V7H11v34h26V14.95ZM11 7v7.95V7v34V7Z"/>
  </svg>
</template>
<script>
export default {
  data: () => ({

  }),
  props: {
    colorx: {
      type: String,
      default: '#89899B'
    }
  }
}
</script>

<style lang="css">
</style>


// WEBPACK FOOTER //
// src/components/shared/icons/PaymentsIcon.vue